export async function isApiReachable(
  url: string,
  timeoutMs = 5000
): Promise<boolean> {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    const response = await fetch(url, {
      method: 'HEAD',
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    return response.ok;
  } catch {
    return false;
  }
}

export async function resolveApiUrl(
  primary: string,
  fallback: string,
  options?: { enabled?: boolean }
): Promise<string> {
  const enabled = options?.enabled ?? true;
  if (!enabled || primary === fallback) {
    return primary;
  }

  return (await isApiReachable(primary)) ? primary : fallback;
}
